function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  display: ",
        ";\n  z-index: 1000;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n\n  [class*='CardContainer'] {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  top: 0;\n  right: 1rem;\n  height: 2rem;\n  width: 2rem;\n  position: absolute;\n  text-align: center;\n  padding: 0;\n  border: 2px solid #ffffff;\n  transform: translateY(-50%);\n  z-index: 2;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 90vh;\n  overflow: auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100px;\n  height: 100px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import Card from "../card";
import styled from "styled-components";
import { withContext } from "../wr-context";
import Button from "../button";
import { FiX } from "react-icons/fi";
var MODAL_BASE_SIZE = 40;
export var ModalScalingFactorsEnum;
(function(ModalScalingFactorsEnum) {
    ModalScalingFactorsEnum["xl"] = "xl";
    ModalScalingFactorsEnum["lg"] = "lg";
    ModalScalingFactorsEnum["md"] = "md";
    ModalScalingFactorsEnum["sm"] = "sm";
    ModalScalingFactorsEnum["xsm"] = "xsm";
})(ModalScalingFactorsEnum || (ModalScalingFactorsEnum = {}));
var sizeScalingFactors = {
    xl: 2.25,
    lg: 1.75,
    md: 1.25,
    sm: 0.75,
    xsm: 0.5
};
var getModalSizePercent = function(size) {
    return "".concat(sizeScalingFactors[size] * MODAL_BASE_SIZE, "%");
};
var Modal = styled.div(_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
}, function(param) {
    var theme = param.theme;
    return theme.components.modal.borderRadius;
});
var Overlay = styled.div(_templateObject1());
var ModalContent = styled.div(_templateObject2(), function(param) {
    var size = param.size;
    return size ? "\n      height: ".concat(getModalSizePercent(size), ";\n      width: ").concat(getModalSizePercent(size), ";\n      max-width: 100vw;\n      min-width: 15rem;\n    ") : "\n      max-width: 40rem;\n    ";
});
var CloseButton = styled(Button)(_templateObject3());
var ModalContentWrapper = styled.div(_templateObject4());
var CloseIcon = styled.div(_templateObject5());
var ModalContainer = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ModalContainer, PureComponent);
    var _super = _createSuper(ModalContainer);
    function ModalContainer() {
        _classCallCheck(this, ModalContainer);
        var _this;
        _this = _super.apply(this, arguments);
        // TODO: Add support for closing via keyboard
        // componentDidMount () {
        //   document.addEventListener('keyup', this.handleKeyClose)
        // }
        // componentWillUnmount () {
        //   document.removeEventListener('keyup', this.handleKeyClose)
        // }
        // handleKeyClose = (e) => {
        //  if (e.code === 'Escape' && this.props.context.state.modal.isOpen) {
        //    this.closeModal()
        //  }
        // }
        _this.closeModalOverlay = function() {
            if (!_this.props.context.state.modal.persistent) {
                _this.props.context.actions.closeModal();
            }
        };
        _this.closeModalButton = function() {
            return _this.props.context.actions.closeModal();
        };
        return _this;
    }
    var _proto = ModalContainer.prototype;
    _proto.render = function render() {
        var _props = this.props, _context = _props.context, _state = _context.state, _modal = _state.modal, body = _modal.body, header = _modal.header, footer = _modal.footer, isOpen = _modal.isOpen, component = _modal.component, _showClose = _modal.showClose, showClose = _showClose === void 0 ? true : _showClose, size = _modal.size;
        return /*#__PURE__*/ React.createElement(Modal, {
            role: "dialog",
            "aria-modal": "true",
            isOpen: isOpen
        }, /*#__PURE__*/ React.createElement(Overlay, {
            onClick: this.closeModalOverlay
        }), /*#__PURE__*/ React.createElement(ModalContent, {
            size: size
        }, /*#__PURE__*/ React.createElement(ModalContentWrapper, null, !component ? /*#__PURE__*/ React.createElement(Card, null, function(param) {
            var Body = param.Body, Header = param.Header, Footer = param.Footer;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, header && /*#__PURE__*/ React.createElement(Header, null, header), body && /*#__PURE__*/ React.createElement(Body, null, body), footer && /*#__PURE__*/ React.createElement(Footer, null, footer));
        }) : component, showClose && /*#__PURE__*/ React.createElement(CloseButton, {
            asIcon: true,
            onClick: this.closeModalButton
        }, /*#__PURE__*/ React.createElement(CloseIcon, null, /*#__PURE__*/ React.createElement(FiX, null))))));
    };
    return ModalContainer;
}(PureComponent);
export default withContext(ModalContainer);
